import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BlogLayout from "../../components/BlogLayout";

const BlogPage3 = () => (
  <BlogLayout
    postId={6921}
    title="The Anatomy of High-Performing Teams – Part 1"
    date="May 28, 2024"
    heroImage="Blog3.png"
  >
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        What defines a stellar team? It's a complex and broad question, one that
        demands exploration. Join me as I break down the intricacies of team
        excellence. In this blog, I'll share a few nuggets of wisdom, drawing
        from my experiences leading diverse teams.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Let's start with a fundamental truth: success thrives on alignment
        between team members. The team must collaborate seamlessly, steadily
        progressing towards a common goal. By reaffirming our commitment to a
        unified objective, each member gains clarity on their role and feels
        empowered to enact meaningful change.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        The Power of a Well-constructed Roadmap
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Empower the team with pre-defined execution guidelines for better
        performance! Leaders pave the way with a roadmap that ignites motivation
        and promotes engagement. An execution governance structure ensures there
        is no room for guesswork, failure, or delay in delivery.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        Open Communication for Great Outcomes
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Leadership is about being approachable, listening with intent, and
        offering feedback when needed. A leader is only as good as their team,
        and fostering a culture of trust and open communication is key to
        tapping into the team's collective potential.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Stay tuned for the next blog, wherein I'll cover the importance of
        recognition and ways to embrace diversity in the workplace.
      </Typography>
    </Box>
  </BlogLayout>
);

export default BlogPage3;
